export const currencyFormat = (num) => {
  if (num != null) {
    var formatter = Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
    return formatter.format(num);
  } else {
    return '';
  }
};
